const registerSelector = "[data-workspace-register]";

const syncSelection = (register) => {
    const rows = Array.from(register.querySelectorAll("[data-register-select]"));
    const selected = rows.filter((item) => item.checked);
    const selectAll = register.querySelector("[data-register-select-all]");
    const container = register.querySelector("[data-register-selected-container]");
    const actions = register.querySelectorAll("[data-register-bulk-action]");

    if (container) {
        container.replaceChildren();
        selected.forEach((checkbox) => {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = container.dataset.inputName || "selectedIds";
            input.value = checkbox.value;
            container.appendChild(input);
        });
    }

    actions.forEach((button) => {
        button.disabled = selected.length === 0;
    });

    if (selectAll) {
        selectAll.checked = selected.length > 0 && selected.length === rows.length;
        selectAll.indeterminate = selected.length > 0 && selected.length < rows.length;
    }
};

const toggleColumn = (register, column, visible) => {
    register.querySelectorAll(`[data-register-table] tr > :nth-child(${column})`).forEach((cell) => {
        cell.hidden = !visible;
    });
};

const setupRegister = (register) => {
    if (register.dataset.workspaceRegisterReady === "true") {
        syncSelection(register);
        return;
    }

    register.dataset.workspaceRegisterReady = "true";
    register.addEventListener("change", (event) => {
        const selectAll = event.target.closest("[data-register-select-all]");
        if (selectAll) {
            register.querySelectorAll("[data-register-select]").forEach((checkbox) => {
                checkbox.checked = selectAll.checked;
            });
            syncSelection(register);
            return;
        }

        if (event.target.closest("[data-register-select]")) {
            syncSelection(register);
            return;
        }

        const columnToggle = event.target.closest("[data-register-column-toggle]");
        if (columnToggle) {
            toggleColumn(register, Number(columnToggle.dataset.registerColumnToggle), columnToggle.checked);
        }
    });

    register.querySelector("[data-register-print]")?.addEventListener("click", () => {
        const excludedRows = Array.from(register.querySelectorAll("[data-register-select]:not(:checked)"))
            .map((checkbox) => checkbox.closest("tr"))
            .filter(Boolean);
        excludedRows.forEach((row) => { row.hidden = true; });
        const restore = () => excludedRows.forEach((row) => { row.hidden = false; });
        window.addEventListener("afterprint", restore, { once: true });
        window.print();
        window.setTimeout(restore, 1000);
    });
    register.querySelector("[data-register-bulk-form]")?.addEventListener("submit", () => syncSelection(register));
    syncSelection(register);
};

const setupWorkspaceRegisters = (root = document) => {
    root.querySelectorAll(registerSelector).forEach(setupRegister);
};

export { setupWorkspaceRegisters };
